import * as React from "react";
import Vault from "../components/Vault";
import { useAuth } from "../hooks/useAuth";

export default function VaultPage() {
  const { user } = useAuth();
  if (!user?.id) return null;
  return <Vault userId={user.id} />;
}
